import { render, staticRenderFns } from "./viewButtons.vue?vue&type=template&id=b0c1e632"
import script from "./viewButtons.vue?vue&type=script&lang=js"
export * from "./viewButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports